/**
 * Skill registry tag used to fetch skills that appear in the Rovo prompt library / empty state actions.
 * Skills tagged with this in the integrations config registry will appear as skill actions with hover cards.
 */
export const PROMPT_LIBRARY_SKILL_TAG = 'rovo-chat-prompt-gallery';
